/* eslint-disable */
export default () => {
  self.onmessage = (e) => {
    const { data, subentity, filterBy, formattedDEnd } = e.data;
    console.log('data', e.data);
    const sameId = (left, right) => left != null && right != null && String(left) === String(right);
    const predicate = (() => {
      return (item) =>
        parseInt(formattedDEnd?.slice(0, 4)) >= parseInt(item.year) &&
        Object.keys(filterBy || {}).every((key) => sameId(item[key], filterBy[key])) &&
        (!item.discontinuedDate || item.discontinuedDate >= formattedDEnd);
    })();

    const bucket = data?.[subentity] || data?.[String(subentity)] || [];
    self.postMessage(bucket.filter(predicate));
  };
};
